import { Component, Renderer2 } from '@angular/core';
import { environment } from '../environments/environment';
import { DnErrorMessageService } from './dn-common/dn-error-display/dn-error-message.service';
import { ThemeLoaderService } from './shared/services/theme-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Login and Registration';
  constructor(private dnErrorMessageService: DnErrorMessageService,
        private themeService: ThemeLoaderService,
        private renderer2: Renderer2,
  ) { 
    this.dnErrorMessageService.errorMessages = environment.common.errorMessages;
    this.themeService.loadTheme(renderer2);
  }  
}
